import AuOneDollarCoin from "assets/Misc/Currency/Coins/AUD/1.png";
import AuTwoDollarCoin from "assets/Misc/Currency/Coins/AUD/2.png";
import AuFiveCentCoin from "assets/Misc/Currency/Coins/AUD/5.png";
import AuTenCentCoin from "assets/Misc/Currency/Coins/AUD/10.png";
import AuTwentyCentCoin from "assets/Misc/Currency/Coins/AUD/20.png";
import AuFiftyCentCoin from "assets/Misc/Currency/Coins/AUD/50.png";
import GBP1PennyCoin from "assets/Misc/Currency/Coins/GBP/1.png";
import GBP1PoundCoin from "assets/Misc/Currency/Coins/GBP/1_dollar.png";
import GBP2PenceCoin from "assets/Misc/Currency/Coins/GBP/2.png";
import GBP2PoundCoin from "assets/Misc/Currency/Coins/GBP/2_dollar.png";
import GBP5PennyCoin from "assets/Misc/Currency/Coins/GBP/5.png";
import GBP10PennyCoin from "assets/Misc/Currency/Coins/GBP/10.png";
import GBP20PennyCoin from "assets/Misc/Currency/Coins/GBP/20.png";
import GBP50PennyCoin from "assets/Misc/Currency/Coins/GBP/50.png";
import NZDTwoDollarCoin from "assets/Misc/Currency/Coins/NZD//2.png";
import NZDOneDollarCoin from "assets/Misc/Currency/Coins/NZD/1.png";
import NZDTenCentCoin from "assets/Misc/Currency/Coins/NZD/10.png";
import NZDTwentyCentCoin from "assets/Misc/Currency/Coins/NZD/20.png";
import NZDFiftyCentCoin from "assets/Misc/Currency/Coins/NZD/50.png";
import USD1CentCoin from "assets/Misc/Currency/Coins/USD/1.png";
import USD25QuarterCoin from "assets/Misc/Currency/Coins/USD/1_quarter.png";
import USD5NickelCoin from "assets/Misc/Currency/Coins/USD/5.png";
import USD10DimeCoin from "assets/Misc/Currency/Coins/USD/10_dime.png";
import USD50CentCoin from "assets/Misc/Currency/Coins/USD/half.png";
import AuFiveDollarNote from "assets/Misc/Currency/Notes/AUD/5_dollar.png";
import AuTenDollarNote from "assets/Misc/Currency/Notes/AUD/10_dollar.png";
import AuTwentyDollarNote from "assets/Misc/Currency/Notes/AUD/20_dollar.png";
import AuFiftyDollarNote from "assets/Misc/Currency/Notes/AUD/50_dollar.png";
import AuHundredDollarNote from "assets/Misc/Currency/Notes/AUD/100_dollar.png";
import GBPFiveDollarNote from "assets/Misc/Currency/Notes/GBP/5_dollar.png";
import GBPTenDollarNote from "assets/Misc/Currency/Notes/GBP/10_dollar.png";
import GBPTwentyDollarNote from "assets/Misc/Currency/Notes/GBP/20_dollar.png";
import GBPFiftyDollarNote from "assets/Misc/Currency/Notes/GBP/50_dollar.png";
import NZDFiveDollarNote from "assets/Misc/Currency/Notes/NZD/5_dollar.png";
import NZDTenDollarNote from "assets/Misc/Currency/Notes/NZD/10_dollar.png";
import NZDTwentyDollarNote from "assets/Misc/Currency/Notes/NZD/20_dollar.png";
import NZDFiftyDollarNote from "assets/Misc/Currency/Notes/NZD/50_dollar.png";
import NZDHundredDollarNote from "assets/Misc/Currency/Notes/NZD/100_dollar.png";
import USD1DollarNote from "assets/Misc/Currency/Notes/USD/1_dollar.png";
import USD2DollarNote from "assets/Misc/Currency/Notes/USD/2_dollar.png";
import USD5DollarNote from "assets/Misc/Currency/Notes/USD/5_dollar.png";
import USD10DollarNote from "assets/Misc/Currency/Notes/USD/10_dollar.png";
import USD20DollarNote from "assets/Misc/Currency/Notes/USD/20_dollar.png";
import USD50DollarNote from "assets/Misc/Currency/Notes/USD/50_dollar.png";
import USD100DollarNote from "assets/Misc/Currency/Notes/USD/100_dollar.png";

export const WidgetNames = {
  blankWidget: "blank-widget",
  interactiveClock: "interactive-clock",
  dice: "dice",
  timer: "timer",
  stopwatch: "stopwatch",
  randomName: "random-name",
  spinner: "spinner",
  calendar: "calendar",
  hundredsChart: "hundreds-chart",
  placeValueMat: "place-value-mat",
  mab: "mab",
  noiseMeter: "noise-meter",
  wellbeing: "wellbeing",
  numberLine: "numberLine",
  scheduler: "scheduler",
  wordBuilder: "word-builder",
  youtube: "youtube",
  freeText: "free-text",
  googleSlides: "google-slides",
  image: "image",
  groupMaker: "group-maker",
  noggle: "noggle",
  boogle: "boogle",
  cartesian: "cartesian",
  freeDrawing: "free-drawing",
  money: "money",
  // learningIntentionWidget: "learning-intention",
  freeHandWritingWidget: "free-handwriting",
};

export const Palette = {
  red: "#ff0000",
  blue: "#0000ff",
  green: "#00ff00",
  yellow: "yellow",
  cyan: "cyan",
  teal: "#33CC99",
  brown: "#4d2600",
  orange: "orange",
  purple: "purple",
  black: "black",
  violet: "violet",
  pink: "#AA336A",
  darkblue: "darkblue",
  maroon: "#660000",
};

export const CurrencyValues: any = {
  AUD: {
    currencySign: "$",
    data: [
      {
        key: 1,
        type: "coin",
        image: AuFiveCentCoin,
        value: 0.05,
        height: "10cqh",
        width: "10cqw",
      },
      {
        key: 2,
        type: "coin",
        image: AuTenCentCoin,
        value: 0.1,
        height: "12cqh",
        width: "12cqw",
      },
      {
        key: 3,
        type: "coin",
        image: AuTwentyCentCoin,
        value: 0.2,
        width: "14cqw",
        height: "14cqh",
      },
      {
        key: 4,
        type: "coin",
        image: AuFiftyCentCoin,
        value: 0.5,
        height: "16cqh",
        width: "16cqw",
      },
      {
        key: 5,
        type: "coin",
        image: AuOneDollarCoin,
        value: 1,
        height: "13cqh",
        width: "13cqw",
      },
      {
        key: 6,
        type: "coin",
        image: AuTwoDollarCoin,
        value: 2,
        width: "12cqw",
        height: "12cqh",
      },
      { key: 7, type: "note", image: AuFiveDollarNote, value: 5 },
      { key: 8, type: "note", image: AuTenDollarNote, value: 10 },
      { key: 9, type: "note", image: AuTwentyDollarNote, value: 20 },
      { key: 10, type: "note", image: AuFiftyDollarNote, value: 50 },
      { key: 11, type: "note", image: AuHundredDollarNote, value: 100 },
    ],
  },
  NZD: {
    currencySign: "$",
    data: [
      {
        key: 1,
        type: "coin",
        image: NZDTenCentCoin,
        value: 0.1,
        height: "10cqh",
        width: "10cqw",
      },
      {
        key: 2,
        type: "coin",
        image: NZDTwentyCentCoin,
        value: 0.2,
        height: "11cqh",
        width: "11cqw",
      },
      {
        key: 3,
        type: "coin",
        image: NZDFiftyCentCoin,
        value: 0.5,
        width: "12cqw",
        height: "12cqh",
      },
      {
        key: 4,
        type: "coin",
        image: NZDOneDollarCoin,
        value: 1,
        width: "13cqw",
        height: "13cqh",
      },
      {
        key: 5,
        type: "coin",
        image: NZDTwoDollarCoin,
        value: 2,
        width: "14cqw",
        height: "14cqh",
      },
      { key: 7, type: "note", image: NZDFiveDollarNote, value: 5 },
      { key: 8, type: "note", image: NZDTenDollarNote, value: 10 },
      { key: 9, type: "note", image: NZDTwentyDollarNote, value: 20 },
      { key: 10, type: "note", image: NZDFiftyDollarNote, value: 50 },
      { key: 11, type: "note", image: NZDHundredDollarNote, value: 100 },
    ],
  },
  GBP: {
    currencySign: "£",
    data: [
      {
        key: 1,
        type: "coin",
        image: GBP1PennyCoin,
        value: 0.01,
        width: "7cqw",
        height: "7cqh",
      },
      {
        key: 2,
        type: "coin",
        image: GBP2PenceCoin,
        value: 0.02,
        width: "8cqw",
        height: "8cqh",
      },
      {
        key: 3,
        type: "coin",
        image: GBP5PennyCoin,
        value: 0.05,
        width: "9cqw",
        height: "9cqh",
      },
      {
        key: 4,
        type: "coin",
        image: GBP10PennyCoin,
        value: 0.1,
        width: "10cqw",
        height: "10cqh",
      },
      {
        key: 5,
        type: "coin",
        image: GBP20PennyCoin,
        value: 0.2,
        width: "11cqw",
        height: "11cqh",
      },
      {
        key: 7,
        type: "coin",
        image: GBP50PennyCoin,
        value: 0.5,
        width: "12cqw",
        height: "12cqh",
      },
      {
        key: 8,
        type: "coin",
        image: GBP1PoundCoin,
        value: 1,
        width: "13cqw",
        height: "13cqh",
      },
      {
        key: 9,
        type: "coin",
        image: GBP2PoundCoin,
        value: 2,
        width: "14cqw",
        height: "14cqh",
      },
      { key: 10, type: "note", image: GBPFiveDollarNote, value: 5 },
      { key: 11, type: "note", image: GBPTenDollarNote, value: 10 },
      { key: 12, type: "note", image: GBPTwentyDollarNote, value: 20 },
      { key: 13, type: "note", image: GBPFiftyDollarNote, value: 50 },
    ],
  },
  USD: {
    currencySign: "£",
    currency: "us",
    data: [
      {
        key: 1,
        type: "coin",
        image: USD1CentCoin,
        value: 0.01,
        width: "10cqw",
        height: "10cqh",
      },
      {
        key: 2,
        type: "coin",
        image: USD5NickelCoin,
        value: 0.25,
        width: "11cqw",
        height: "11cqh",
      },
      {
        key: 3,
        type: "coin",
        image: USD10DimeCoin,
        value: 0.1,
        width: "12cqw",
        height: "12cqh",
      },
      {
        key: 4,
        type: "coin",
        image: USD25QuarterCoin,
        value: 0.25,
        width: "13cqw",
        height: "13cqh",
      },
      {
        key: 5,
        type: "coin",
        image: USD50CentCoin,
        value: 0.5,
        width: "14cqw",
        height: "14cqh",
      },
      { key: 7, type: "note", image: USD1DollarNote, value: 1 },
      { key: 8, type: "note", image: USD2DollarNote, value: 2 },
      { key: 9, type: "note", image: USD5DollarNote, value: 5 },
      { key: 10, type: "note", image: USD10DollarNote, value: 10 },
      { key: 11, type: "note", image: USD20DollarNote, value: 20 },
      { key: 12, type: "note", image: USD50DollarNote, value: 50 },
      { key: 13, type: "note", image: USD100DollarNote, value: 100 },
    ],
  },
};

export const WidgetNameTypes = Object.values(WidgetNames);
